module.exports = __webpack_public_path__ + "img/loading.ae70a5a2.png";